import {useEffect} from 'react'

export default (predicate: boolean, onFail: () => void) => {
  useEffect(() => {
    if (!predicate) {
      onFail()
    }
  }, [predicate, onFail])

  return !predicate
}
